module.exports = __webpack_public_path__ + "static/media/16.onenote.32772fe5.svg";